/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProcessInputs */

const et_nav_process = /** @type {(inputs: Nav_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protsess`)
};

const en_nav_process = /** @type {(inputs: Nav_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process`)
};

/**
* | output |
* | --- |
* | "Process" |
*
* @param {Nav_ProcessInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_process = /** @type {((inputs?: Nav_ProcessInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProcessInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_nav_process(inputs)
	return en_nav_process(inputs)
});